export type StateSelector<T> = (rootState) => T;
